<template>
  <div id="design-glife-page">
    <b-row no-gutters>
      <b-col>
        <DesignNav></DesignNav>
      </b-col>
    </b-row>

    <div class="design-body content-body">
      <div class="content-inside">
        <div style="margin-top: 1px;">
          <span class="label-helper align-top">GLife</span>
          <i class="guide-tooltip" id="customer-app"></i>
          <b-popover
            target="customer-app"
            triggers="hover"
            content="Create the basic design theme of your GLife."
          ></b-popover>
        </div>

        <b-row :class="planId == 1 || planId == 2 ? 'disableContent' :''">
          <b-col cols="1">
            <router-link
              :to="planId != 1 && planId != 2 ? '/design/design/create-glife-design' : ''"
              class="btn create-page"
              v-b-tooltip.hover
              :title="planId == 1 || planId == 2 ? unavailableToPlan : ''"
            >
              <img src="@/assets/images/mechanics/add-inactive.svg" alt="Add" />
              <br />Create
            </router-link>
          </b-col>
          <b-col>
            <carousel
              style="margin-left: 60px"
              :per-page="3"
              :spacePadding="10"
              :mouse-drag="false"
              :paginationEnabled="false"
              :navigationEnabled="true"
            >
              <slide v-for="(gLife, index) in gLifeDesignList" :key="index">
                <div class="col-container">
                  <b-row>
                    <b-col>
                      <span :class="['app-title ' + ((gLife.published)? 'selected' : '')]">
                        <img
                          height="20px"
                          src="@/assets/images/mechanics/mobile.svg"
                          alt="Edit Icon"
                          style="margin-right: 5px"
                        />
                        {{(gLife.published)? 'Published' : 'Draft'}}
                      </span>
                    </b-col>
                    <b-col class="text-right">
                      <switches
                        @click.native="publishGlife(gLife.uuid)"
                        v-model="gLife.published"
                        theme="custom"
                        color="primary"
                        type-bold="true"
                        text-enabled=" "
                        text-disabled=" "
                        style="position: relative; top: -12px;"
                      ></switches>

                      <router-link
                        :to="{ name: 'UpdateGlifeDesign', params: { id: gLife.uuid }}"
                      >
                        <img
                          height="20px"
                          src="@/assets/images/achievement/action/edit.svg"
                          alt="Edit Icon"
                          style="margin-left: 5px"
                        />
                      </router-link>

                      <i class="action-button" @click="confirmDelete(gLife.uuid, gLife.name)">
                        <img
                          src="@/assets/images/achievement/action/delete.svg"
                          alt="Delete Button"
                        />
                      </i>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="2">
                      <label
                        class="theme-span"
                        :style="'background-color: ' + gLife.button_color + '; color: ' + gLife.font_color"
                      >Aa</label>
                    </b-col>
                    <b-col style="margin: 5px;">
                      <strong>{{ gLife.name }}</strong>
                      <p v-if="gLife.updated_at">
                        Last edited: {{ gLife.updated_at }}
                      </p>
                    </b-col>
                  </b-row>
                </div>
              </slide>
            </carousel>
          </b-col>
        </b-row>
      </div>
    </div>
    
    <b-modal ref="delete-modal" title="Delete GLife Design">
      <p class="modal-main-message">Are you sure you want delete this Design:</p>
      <h3 class="modal-secondary-message">{{ toDeleteName }}</h3>
      <div slot="modal-footer">
        <b-btn
          variant="ghost"
          class="mr-1 btn-cancel"
          @click="$refs['delete-modal'].hide()"
        >Cancel</b-btn>
        <b-btn
          variant="primary"
          class="ml-1"
          @click="handleDelete"
        >Yes, Delete</b-btn>
        <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import permission from "@/services/user.permission";
import { mapState } from "vuex";
import Switches from "vue-switches";
import DesignNav from './components/DesignNav';
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "design-nav",
  data() {
    return {
      msg: "Design Nav",
      permission: permission,
      env: process.env.VUE_APP_MODE,
      customerAppUuid: null,
      customerAppName: null,
      merchantAppUuid: null,
      merchantAppName: null,
      toDeleteUuid: null,
      toDeleteName: null
    };
  },
  components: {
    Switches,
    Carousel,
		Slide,
		DesignNav
  },
  computed: {
    ...mapState("designs", {
      loading: state => state.loading,
      errors: state => state.errors,
      details: state => state.details,
      gLifeDesignList: state => state.gLifeDesignList
    }),
    ...mapState("auth", ["planId", "unavailableToPlan"])
  },

  methods: {
    confirmDelete(uuid, name) {
      this.$refs["delete-modal"].show();
      this.toDeleteUuid = uuid;
      this.toDeleteName = name;
    },
    async handleDelete() {
      await this.$store.dispatch("designs/deleteGLifeDesign", this.toDeleteUuid);
      this.$store.dispatch("designs/getGLifeDesignList");
      this.$refs["delete-modal"].hide();
    },
    async publishGlife(uuid) {
      if (!this.loading) {
        await this.$store.dispatch("designs/publishGLifeDesign", { uuid });
        this.$store.dispatch("designs/getGLifeDesignList");
      }
    },
  },
  created() {
    this.$store.dispatch("designs/getGLifeDesignList");
  }
};
</script>

<style lang="scss" scoped>
.create-page {
  border-radius: 5px;
  border: 1px dashed #b8b8b8;
  padding: 25px;
}

.col-container {
  position: relative;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #f8f8fa;
  background-clip: border-box;
  border-radius: 0.25rem;
  padding: 5px;
  margin-right: 5px;
  margin-left: 5px;
}

.app-title {
  font-size: 0.7em;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
}

.app-title.selected {
  color: #ff8828;
}

.col-container p {
  font-size: 0.6em;
}

.col-container strong {
  font-size: 0.7em;
}

.col-container .theme-span {
  font-size: 1em;
  padding: 0.6em 0.6em;
  margin-top: 0.4em;
  margin-left: 0.3em;
  border: 1px #ddd solid;
  border-radius: 3px;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
}

.square {
  width: 100%;
}

/* DivTable.com */
.divTable {
  display: table;
  width: 100%;
}
.divTableRow {
  display: table-row;
}
.divTableCell,
.divTableHead {
  border: 1px solid #999999;
  display: table-cell;
  padding: 3px 10px;
}
.divTableHeading {
  background-color: #eee;
  display: table-header-group;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
}
.divTableFoot {
  background-color: #eee;
  display: table-footer-group;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
}
.divTableBody {
  display: table-row-group;
}

</style>
<style lang="scss">
#design-glife-page {
.vue-switcher .vue-switcher__label {
  z-index: -1;
}
}
</style>

